import React, { useEffect, useState } from 'react';
import axios from 'axios';
import StarIcon from '@material-ui/icons/Star';
import { load } from '@cashfreepayments/cashfree-js';
import configureStore from '../../../store/configureStore';
import Loader from '../../common/Loader';
import { update_user_profile } from '../../../actions/action-userProfiles';
import config from '../../../config';
const { payemntSecretName, razorpayId } = config;

const store = configureStore();

export default function PaymentPage(props) {
  const { userDetails, packageDetails, handleClose } = props;
  const [paymentOrder, setPaymentOrder] = useState(null);
  const [agree, setAgree] = useState(false);
  const [cf, setCf] = useState(null);

  useEffect(() => {
    initCashfree();
  }, []);

  useEffect(() => {
    if (cf) {
      placeOrder();
    }
  }, [cf]);

  const initCashfree = async () => {
    try {
      const cashfree = await load({
        mode:
          payemntSecretName === 'demo_leaperx_cashfree'
            ? 'sandbox'
            : 'production',
      });
      setCf(cashfree);
    } catch (err) {
      console.error('Cashfree SDK load failed:', err);
    }
  };

  const { apiEndpoint, credentials } = store.getState().jwt.api;

  const placeOrder = async () => {
    try {
      const { apiEndpoint, credentials } = store.getState().jwt.api;
      const jwt = `${credentials.idToken.jwtToken}`;

      const cleanPhone = (userDetails.data.phone_number || 'NA').replace(
        /\+/g,
        ''
      );

      const customerId = `${userDetails.data.name}${cleanPhone}`.replace(
        /[^a-zA-Z0-9]/g,
        ''
      );

      const payload = {
        orderData: {
          order_amount: packageDetails.amount,
          order_currency: packageDetails.currency,
          customer_details: {
            customer_id: customerId,
            customer_name: userDetails.data.name,
            customer_email: userDetails.data.email,
            customer_phone: userDetails.data.phone_number || '',
          },
        },
        provider: payemntSecretName,
        type: 'external',
      };

      const response = await axios.post(
        `${apiEndpoint}/paymentorder`,
        payload,
        {
          headers: { Authorization: jwt },
        }
      );

      setPaymentOrder(response.data);
    } catch (err) {
      console.error('Payment failed:', err);
    }
  };

  const paymentSucess = async (paymentResponse) => {
    let newUserDetails = { ...userDetails };

    if (newUserDetails && newUserDetails.data) {
      newUserDetails.data.subscriptionStatus = 'subscribed';
      newUserDetails.data.paymentDetails = paymentResponse;
      newUserDetails.data.bizRegistrationStatus = 'inprogress';
    }

    console.log('newUserDetails :: ', newUserDetails);
    if (newUserDetails?.data?.username)
      await store.dispatch(
        update_user_profile(newUserDetails, newUserDetails?.data?.username)
      );

    window.location.reload();
  };

  const getOrderStatus = async (orderId, paymentId) => {
    try {
      const { apiEndpoint, credentials } = store.getState().jwt.api;
      const jwt = `${credentials.idToken.jwtToken}`;

      const response = await axios.get(
        `${apiEndpoint}/paymentorder?orderId=${orderId}&provider=${payemntSecretName}`,
        {
          headers: { Authorization: jwt },
        }
      );

      console.log('Order Status API Response:', response.data);

      let orderStatus;
      if (response.data.payment_status === 'SUCCESS') {
        await paymentSucess({
          status: 'Success',
        });
        orderStatus = 'Success';
      } else if (response.data.payment_status === 'PENDING') {
        orderStatus = 'Pending';
      } else {
        orderStatus = 'Failure';
      }

      return orderStatus;
    } catch (err) {
      console.error('Error fetching order status:', err);
      return 'Failure';
    }
  };

  const showCashfree = () => {
    handleClose();
    console.log('paymentOrder', paymentOrder?.payment_session_id);
    if (!cf || !paymentOrder?.payment_session_id) {
      alert('Payment not ready yet');
      return;
    }

    cf.checkout({
      paymentSessionId: paymentOrder?.payment_session_id,
      redirectTarget: '_modal',
    }).then(async (result) => {
      console.log('Payment result:', result, paymentOrder?.order_id);

      if (result.error) {
        alert('Payment error: ' + result.error.message);
        return;
      }

      if (paymentOrder?.order_id) {
        const status = await getOrderStatus(
          paymentOrder?.order_id,
          paymentOrder?.cf_order_id
        );
        console.log('Final Order Status:', status);
      }
    });
  };

  const checkboxHandler = () => setAgree(!agree);

  return (
    <div className="PaymentPopUpWrapper">
      {paymentOrder ? (
        <div>
          <div className="PaymentPopUpIcon">
            <StarIcon style={{ fontSize: 60, color: '#fff' }} />
          </div>
          <div className="PaymentPopUpTitle">LeaperX Life Long Membership</div>
          <div className="PaymentPopUpDes">
            Become a member of the club to grow your business to next level.
            After you pay the membership fee register your business and start
            scaling.
          </div>
          <div className="PaymentPopUpEyebrow">One Time</div>
          <div className="price">Rs {packageDetails.amount}/- including GST</div>
          <div className="PaymentPopUpTerms">
            <input type="checkbox" id="agree" onChange={checkboxHandler} />
            <label htmlFor="agree">
              I agree to{' '}
              <a
                href="https://leaperx.com/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                terms and conditions
              </a>
            </label>
          </div>
          <button
            disabled={!agree}
            onClick={showCashfree}
            style={{
              opacity: !agree ? 0.5 : 1,
              cursor: !agree ? 'not-allowed' : 'pointer',
            }}
          >
            Pay Now
          </button>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}
